import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const searchUser = (payload, userName) => {
    return api.makeRequest({
        url: `/v1.0/base/searchUser?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getUserDetail = (payload) => {
    return api.makeRequest({
        url: `/v1.0/base/getUserDetail`,
        method: 'POST',
        data: payload
    })
}

export const updateUser = (payload, userName) => {
    return api.makeRequest({
        url: `/v1.0/base/updateUser?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const addUser = (payload, userName) => {
    return api.makeRequest({
        url: `/v1.0/base/addUser?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getAllRole = (payload, userName) => {
    return api.makeRequest({
        url: `/v1.0/base/getAllRole?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getRoleByUserName = (payload) => {
    return api.makeRequest({
        url: `/v1.0/base/getRolesByUserName`,
        method: 'POST',
        data: payload
    })
}

export const changePassword = (payload) => {
    return api.makeRequest({
        url: `/crm/changePass`,
        method: 'POST',
        data: payload
    })
}

export const resetPassword = (payload) => {
    return api.makeRequest({
        url: `/v1.0/base/resetPass`,
        method: 'POST',
        data: payload
    })
}

export const searchTenant = (payload, userName) => {
    return api.makeRequest({
        url: `v1.0/base/searchTenant?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getExtensions = (payload, userName) => {
    return api.makeRequest({
        url: `v1.0/base/getExtensions?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getListExtensions = (payload, userName) => {
    return api.makeRequest({
        url: `v1.0/base/getExtensions?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getCalloutQueue = (payload, userName) => {
    return api.makeRequest({
        url: `/v1.0/base/getCalloutQueue?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const assignCalloutQueue = (payload, userName) => {
    return api.makeRequest({
        url: `/v1.0/base/assignCalloutQueue?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}
